// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { FileIdBuf } from '../file/file-id-buf.js';


export class SearchFacetTypeBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):SearchFacetTypeBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsSearchFacetTypeBuf(bb:flatbuffers.ByteBuffer, obj?:SearchFacetTypeBuf):SearchFacetTypeBuf {
  return (obj || new SearchFacetTypeBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsSearchFacetTypeBuf(bb:flatbuffers.ByteBuffer, obj?:SearchFacetTypeBuf):SearchFacetTypeBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new SearchFacetTypeBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

exists():boolean|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null;
}

equals():string|null
equals(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
equals(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

notEquals():string|null
notEquals(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
notEquals(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

startsWith():string|null
startsWith(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
startsWith(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

contains():string|null
contains(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
contains(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

fileIn(obj?:FileIdBuf):FileIdBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new FileIdBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileOnlyIn(obj?:FileIdBuf):FileIdBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? (obj || new FileIdBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

greaterThan():number|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : null;
}

greaterThanEqual():number|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : null;
}

lessThan():number|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : null;
}

lessThanEqual():number|null {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : null;
}

afterDate():bigint|null {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : null;
}

onOrAfterDate():bigint|null {
  const offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : null;
}

beforeDate():bigint|null {
  const offset = this.bb!.__offset(this.bb_pos, 30);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : null;
}

onOrBeforeDate():bigint|null {
  const offset = this.bb!.__offset(this.bb_pos, 32);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : null;
}

nearFile(obj?:FileIdBuf):FileIdBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 34);
  return offset ? (obj || new FileIdBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

nearColor():string|null
nearColor(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
nearColor(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 38);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

hasTag():string|null
hasTag(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
hasTag(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 40);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

oneOf(index: number):string
oneOf(index: number,optionalEncoding:flatbuffers.Encoding):string|Uint8Array
oneOf(index: number,optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 42);
  return offset ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding) : null;
}

oneOfLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 42);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

nearImageText():string|null
nearImageText(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
nearImageText(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 44);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

nearAudioText():string|null
nearAudioText(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
nearAudioText(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 46);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

nearDocLikeText():string|null
nearDocLikeText(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
nearDocLikeText(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 48);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

nearVideoText():string|null
nearVideoText(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
nearVideoText(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 50);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

static startSearchFacetTypeBuf(builder:flatbuffers.Builder) {
  builder.startObject(24);
}

static addExists(builder:flatbuffers.Builder, exists:boolean) {
  builder.addFieldInt8(0, +exists, null);
}

static addEquals(builder:flatbuffers.Builder, equalsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, equalsOffset, 0);
}

static addNotEquals(builder:flatbuffers.Builder, notEqualsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, notEqualsOffset, 0);
}

static addStartsWith(builder:flatbuffers.Builder, startsWithOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, startsWithOffset, 0);
}

static addContains(builder:flatbuffers.Builder, containsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, containsOffset, 0);
}

static addFileIn(builder:flatbuffers.Builder, fileInOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, fileInOffset, 0);
}

static addFileOnlyIn(builder:flatbuffers.Builder, fileOnlyInOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, fileOnlyInOffset, 0);
}

static addGreaterThan(builder:flatbuffers.Builder, greaterThan:number) {
  builder.addFieldFloat64(7, greaterThan, null);
}

static addGreaterThanEqual(builder:flatbuffers.Builder, greaterThanEqual:number) {
  builder.addFieldFloat64(8, greaterThanEqual, null);
}

static addLessThan(builder:flatbuffers.Builder, lessThan:number) {
  builder.addFieldFloat64(9, lessThan, null);
}

static addLessThanEqual(builder:flatbuffers.Builder, lessThanEqual:number) {
  builder.addFieldFloat64(10, lessThanEqual, null);
}

static addAfterDate(builder:flatbuffers.Builder, afterDate:bigint) {
  builder.addFieldInt64(11, afterDate, null);
}

static addOnOrAfterDate(builder:flatbuffers.Builder, onOrAfterDate:bigint) {
  builder.addFieldInt64(12, onOrAfterDate, null);
}

static addBeforeDate(builder:flatbuffers.Builder, beforeDate:bigint) {
  builder.addFieldInt64(13, beforeDate, null);
}

static addOnOrBeforeDate(builder:flatbuffers.Builder, onOrBeforeDate:bigint) {
  builder.addFieldInt64(14, onOrBeforeDate, null);
}

static addNearFile(builder:flatbuffers.Builder, nearFileOffset:flatbuffers.Offset) {
  builder.addFieldOffset(15, nearFileOffset, 0);
}

static addNearColor(builder:flatbuffers.Builder, nearColorOffset:flatbuffers.Offset) {
  builder.addFieldOffset(17, nearColorOffset, 0);
}

static addHasTag(builder:flatbuffers.Builder, hasTagOffset:flatbuffers.Offset) {
  builder.addFieldOffset(18, hasTagOffset, 0);
}

static addOneOf(builder:flatbuffers.Builder, oneOfOffset:flatbuffers.Offset) {
  builder.addFieldOffset(19, oneOfOffset, 0);
}

static createOneOfVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startOneOfVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addNearImageText(builder:flatbuffers.Builder, nearImageTextOffset:flatbuffers.Offset) {
  builder.addFieldOffset(20, nearImageTextOffset, 0);
}

static addNearAudioText(builder:flatbuffers.Builder, nearAudioTextOffset:flatbuffers.Offset) {
  builder.addFieldOffset(21, nearAudioTextOffset, 0);
}

static addNearDocLikeText(builder:flatbuffers.Builder, nearDocLikeTextOffset:flatbuffers.Offset) {
  builder.addFieldOffset(22, nearDocLikeTextOffset, 0);
}

static addNearVideoText(builder:flatbuffers.Builder, nearVideoTextOffset:flatbuffers.Offset) {
  builder.addFieldOffset(23, nearVideoTextOffset, 0);
}

static endSearchFacetTypeBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

}
